import { RichInboxProviderState } from "./RichInboxProvider.types";
import { createContext } from "react";

export const RichInboxProviderContext = createContext<
  RichInboxProviderState | undefined
>(undefined);
